const referralRoute = {
    "/referral": {
        title: "Referral",
    }
};

const insufficientInformation = () => ({
    "/:ohCaseId/insufficient-information/:taskId": {
        title: "Action",
        ...referralRoute
    }
});

const viewReferralReport = {
    "/:ohCaseId/view-report/:viewReportTaskId": {
        title: "Report"
    },
    "/:ohCaseId/view-old-report/*/:viewReportTaskId": {
        title: "Report"
    }
};

const writeReferralReport = {
    "/:ohCaseId/view-write-report/:writeReportTaskId": {
        title: "Report"
    },
    "/:ohCaseId/view-write-old-report/*/:writeReportTaskId": {
        title: "Report"
    }
};

const ppqReport = {
    "/:ohCaseId/view-ppq-report/:viewReportTaskId": {
        title: "Report"
    }
};

const healthSurveillanceCertificate = {
    "/:ohCaseId/view-health-surveillance-certificate/:taskId": {
        title: "Health Surveillance Certificate"
    }
};

const allImmsCompletedForRoleCertificate = {
    "/:employeeRecordId/:ohCaseId/all-imms-completed-for-role-certificate/:taskId": {
        title: "All Immunisations Completed For Role Certificate"
    }
};

const immunisationClearCertificate = {
    "/:employeeRecordId/:ohCaseId/immunisation-clear-certificate/:taskId": {
        title: "Immunisation Clearance Certificate"
    }
};

const physiotherapyReferralReport = {
    "/:ohCaseId/view-physiotherapy-report/:viewReportTaskId": {
        title: "Physiotherapy Report"
    },
    "/:ohCaseId/view-old-physiotherapy-report/*/:viewReportTaskId": {
        title: "Physiotherapy Report"
    }
};

const writePhysiotherapyReferralReport = {
    "/:ohCaseId/view-write-physiotherapy-report/:writeReportTaskId": {
        title: "Physiotherapy Report"
    },
    "/:ohCaseId/view-write-old-physiotherapy-report/*/:viewReportTaskId": {
        title: "Physiotherapy Report"
    }
};

const mhpTreatmentReport = {
    "/:ohCaseId/view-mhp-treatment-report/:viewReportTaskId": {
        title: "MHP Treatment Report"
    }
};

const workAdjustmentsRoutes = {
    "/:ohCaseId/complete-initial-work-adjustment-details/:taskId": {
        title: "Initial Work Adjustment Details"
    },
    "/:ohCaseId/process-update-work-adjustment-questionnaire/:taskId": {
        title: "Process Work Adjustment Form"
    }
};

const managerFeedbackOnReport = {
    "/:ohCaseId/manager-feedback-on-report/:taskId": {
        title: "Manager Feedback on Report"
    }
};

const managerSatisfactionFollowUpQuestionnaire = {
    "/:ohCaseId/follow-up-questionnaire/:taskId": {
        title: "Manager Satisfaction Follow Up Questionnaire"
    }
};

export const routes = {
    "/actions": {
        title: "Actions",
        ...insufficientInformation(),
        ...viewReferralReport,
        ...writeReferralReport,
        ...ppqReport,
        ...healthSurveillanceCertificate,
        ...allImmsCompletedForRoleCertificate,
        ...immunisationClearCertificate,
        ...physiotherapyReferralReport,
        ...writePhysiotherapyReferralReport,
        ...workAdjustmentsRoutes,
        ...managerFeedbackOnReport,
        ...managerSatisfactionFollowUpQuestionnaire,
        ...mhpTreatmentReport
    }
};
